module.exports = __webpack_public_path__ + "img/bubble_enroll_bg@2x.404035f8.png";